<template>
  <v-app app style="background-color: #f0f0f0">
    <!--<v-system-bar window color="warning">
      <v-spacer />
      <v-icon color="white">mdi-alert-outline</v-icon>

      <div style="color: white; text-align: center;"><b>{{ $t('info_bar_maintanance') }}</b></div>

      <v-spacer />
    </v-system-bar>-->
    <app-navbar />
    <alert-snackbar />
    <v-main class="
        px-5 px-md-13 px-sm-0 px-lg-16
        pb-md-8 pb-lg-10 pb-sm-0 pt-5
        mb-10
      ">
      <v-container style="max-width: 1280px; position: relative;" class="pa-0 align-center">
        <router-view></router-view>
      </v-container>
    </v-main>
    <bottom-footer></bottom-footer>
  </v-app>
</template>

<script>
import AppNavbar from "./components/layout/AppNavbar.vue";
import AlertSnackbar from "./components/layout/AlertSnackbar";
import BottomFooter from "./components/layout/BottomFooter";

export default {
  name: "App",
  components: {
    AppNavbar,
    AlertSnackbar,
    BottomFooter,
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  created() {
    this.$vuetify.theme.themes.light.primary = this.currentUser
      ? this.currentUser.whitelabeling_pack.style
      : "#1E6569";
    this.$vuetify.theme.themes.light.secondary = this.currentUser
      ? this.currentUser.whitelabeling_pack.style
      : "#1E6569";
    this.$vuetify.theme.themes.light.accent = this.currentUser
      ? this.currentUser.whitelabeling_pack.style
      : "#1E6569";
  },
};
</script>